module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-list', {
    attrs: {
      "media-list": "",
      "virtual": "",
      "virtual-rows-after": _vm.virtualRowsAfter,
      "virtual-items": _vm.virtualItems,
      "virtual-height": _vm.virtualHeight,
      "virtual-render-item": _vm.renderItem
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b21358"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VVirtualCards.vue
// module id = 137
// module chunks = 1